// 使用常量替代mutation事件类型。
export const SET_INFO = 'SET_INFO'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js